import { Circle, BarChart2 } from 'react-feather'

export default [
	{
		id: 'rank',
		title: 'Xếp hạng',
		icon: <BarChart2 size={20} />,
		children: [
			{
				id: 'character',
				title: 'Nhân vật',
				icon: <Circle size={12} />,
				navLink: '/rank/character'
			},
			{
				id: 'guild',
				title: 'Bang hội',
				icon: <Circle size={12} />,
				navLink: '/rank/guild'
			}
		]
	}
]
